<template>
    <div class="consult">
        <div class="consult-item" onclick="window.open('https://wpa.qq.com/msgrd?v=3&uin=2885579324&site=qq&menu=yes')"
            @click="count('QQ咨询')">
            <img src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/qq@2x.png" alt="">
            <span>QQ咨询</span>
        </div>
        <div class="consult-item"
            onclick="window.open('https://p.qiao.baidu.com/cps/chat?siteId=17215253&userId=24709704&siteToken=ee23978d9ed5a1ec3d9d7b4d73e7dca9')"
            @click="count('在线咨询')">
            <img style="width:26px;height:21px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/zx@2x.png" alt="">
            <span>在线咨询</span>
        </div>
        <a-popover placement="left">
            <template #content>
                <div id="wxConsult">
                    <span>微信扫一扫</span>
                    <img style="width:120px;height:120px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/code2@2x.png" alt="">
                </div>
            </template>
            <div class="consult-item" @mouseleave="count('微信咨询', 'mouseleave')">
                <img style="width:26px;height:21px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/wx@2x.png" alt="">
                <span>微信咨询</span>
            </div>
        </a-popover>

        <div class="consult-item"
            onclick="window.open('http://www.taobao.com/go/market/webww/ww.php?spm=a1z13.2196529.0.0.358c5acaIs4K6D&ver=3&touid=杭州麦苗省油宝%3A夏末&siteid=cntaobao&status=1&charset=utf-8')"
            @click="count('旺旺咨询')">
            <img style="width:21px;height:22px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/ww@2x.png" alt="">
            <span>旺旺咨询</span>
        </div>
        <div class="consult-item" onclick="window.open('https://jdcs.jd.com/index.action?venderId=618008')"
            @click="count('咚咚咨询')">
            <img style="width:21px;height:22px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dd@2x.png" alt="">
            <span>咚咚咨询</span>
        </div>
        <div class="consult-item">
            <a @click="scrollTop">
                <img style="width:20px;height:15px" src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/top@2x.png" alt="">
            </a>
        </div>
    </div>
</template> 
<script lang="ts">
import { baiduStatistics } from "../../utils/common"
export default {
    name: 'RightZX',
    methods: {
        count(text, key = 'click') {
            baiduStatistics(text, key)
        },
        scrollTop(){
            window.scrollTo(0, 0)
        }
    }
}

</script>
<style lang="less" scoped>
.consult {
    position: fixed;
    right: 30px;
    top: 30%;

    &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 70px;
        background-color: #454545;

        img {
            width: 19px;
            height: 22px;
        }

        span {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #fff;
            margin-top: 6px;
        }
    }

    &-item:last-child {
        background-color: #f7f8fa00;
    }

    &-item:hover {
        background-color: #2C87EE;
    }

    &-item:last-child:hover {
        background-color: #f7f8fa00;
    }


}

#wxConsult {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>   